import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesReportesAdmin() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: null, items: [
      { label: "Calificadora Clientes", icon: "fas fa-exclamation-circle", color: "#f59e0b", href: "/CalificadoraClientes", desc: "Score de clientes", enabled: !!user.edoCtaClientes },
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#10b981", href: "/ListadoAbonos", desc: "Pagos recibidos", enabled: !!user.abonos },
      { label: "Antiguedad Vencido", icon: "fas fa-dollar-sign", color: "#ef4444", href: "/AntiguedadSaldosVencido", desc: "Saldos vencidos", enabled: !!user.abonos },
      { label: "Antiguedad por Cobrar", icon: "fas fa-dollar-sign", color: "#3b82f6", href: "/AntiguedadSaldosPorCobrar", desc: "Saldos por cobrar", enabled: !!user.abonos },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Reportes Admin"
      descripcion="Cobranza, saldos y calificacion de clientes"
      icono="fas fa-dollar-sign"
      color="#6366f1"
      secciones={SECCIONES}
    />
  );
}

export default BotonesReportesAdmin;
